import { useMemo, useState } from "react";
import { useAdminUsers } from "../../../lib/api/admin.api";
import type { UserWithCounts } from "../../../lib/api/admin.api";
import { AdminUserRow } from "./AdminUserRow";
import { AdminResetLinkModal } from "./AdminResetLinkModal";

export function AdminUsersTab() {
  const { data: users, isLoading } = useAdminUsers();
  const [resetTarget, setResetTarget] = useState<UserWithCounts | null>(null);
  const [search, setSearch] = useState("");
  const currentUserId = localStorage.getItem("palnia_user_id") ?? "";

  const filtered = useMemo(() => {
    if (!users) return [];
    if (!search.trim()) return users;
    const q = search.toLowerCase();
    return users.filter(
      (u) => u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q),
    );
  }, [users, search]);

  if (isLoading) return <p className="text-ink-muted text-sm">Chargement...</p>;
  if (!users?.length) return <p className="text-ink-muted text-sm">Aucun utilisateur</p>;

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher par nom ou email..."
            className="flex-1 px-3 py-2 text-sm bg-surface-alt border border-border rounded-lg
              placeholder:text-ink-faint focus:outline-none focus:ring-2 focus:ring-accent/30"
          />
          <span className="text-xs text-ink-faint shrink-0">
            {filtered.length}/{users.length}
          </span>
        </div>
        {filtered.map((user) => (
          <AdminUserRow
            key={user.id}
            user={user}
            currentUserId={currentUserId}
            onResetPassword={setResetTarget}
          />
        ))}
      </div>
      {resetTarget && (
        <AdminResetLinkModal
          user={resetTarget}
          onClose={() => setResetTarget(null)}
        />
      )}
    </>
  );
}
